import * as React from 'react'
import { Theme } from '@mui/material/styles'
import { styles } from './useStyles'
import { LocationLinkProps } from './typings'
import { useGetLocationUrl } from '@user/store/authorization/hooks'

import Typography, { TypographyProps } from '@mui/material/Typography'
import LaunchIcon from '@mui/icons-material/Launch'
import Link from '@mui/material/Link'

export function LocationLink(
  props: LocationLinkProps & {
    variant?: TypographyProps['variant']
    fontSize?: TypographyProps['fontSize']
    iconSize?: 'small' | 'inherit' | 'large' | 'medium'
  },
) {
  const {
    externalLocationId,
    externalLocationCode,
    hideLocationPrefix = false,
    billingLocation = false,
    icon = false,
    inline = false,
    variant = 'body2',
    fontSize = undefined,
    iconSize = 'inherit',
  } = props

  const locationUrl = useGetLocationUrl(externalLocationId, billingLocation)

  return (
    <Typography
      variant={variant}
      sx={{ display: inline ? 'inline' : 'block', fontSize: fontSize }}
    >
      {!hideLocationPrefix && `Location: `}
      <Link
        href={locationUrl}
        target="_blank"
        rel="noreferrer"
        sx={styles.link}
        data-test-id={`location-card-view-${externalLocationId}`}
      >
        {externalLocationCode}
        {icon && (
          <LaunchIcon
            sx={{
              marginLeft: (theme: Theme) => theme.spacing(0.8),
              marginBottom: (theme: Theme) => theme.spacing(0.0),
              width: '18px',
              height: '18px',
            }}
            fontSize={iconSize}
          />
        )}
      </Link>
    </Typography>
  )
}
